import React, { Fragment } from 'react';

class Body extends React.Component 
{
    render() 
	{
        return (
            <div id="-sf-body-id-" className="business-body page-overflow middle">
                <div className='business-body-center'>
                    <Fragment>
                        {this.props.children}
                    </Fragment>
                </div>
                
            </div>
        );
    }
}

export default Body